export const baseUrl = 'https://pmd-nrk.akamaized.net/urix/koranskolene/'
export const responsiveWidths = [320, 768, 1280, 1920, 2400]

function prepareUrl(url, width) {
  return baseUrl + url.replace('{{width}}', width)
}

export function createDefaultSrc(url) {
  return prepareUrl(url, 1920)
}

export function createPmdSrcSet(url) {
  return responsiveWidths.map((width) => `${prepareUrl(url, width)} ${width}w`).join(', ')
}
